import gql from "graphql-tag";
import CommentOrReplyAuthorFields from "./CommentOrReplyAuthorFields";
import EditableCommentFields from "./EditableCommentFields";
import LockableCommentFields from "./LockableCommentFields";
import PinnableCommentFields from "./PinnableCommentFields";
import ReactableFields from "./ReactableFields";

export default gql`
  fragment AssetDiscussionCommentFields on AssetDiscussionComment {
    _id
    shortId
    bodyAsPlainText
    postedAt

    asset {
      ... on AmericanCompanyIssuer {
        _id
        name
        tickerSymbols
        businessDescription
        primaryTickerSymbol
        primaryLogo: standardLogo {
          url
        }
        niceLogo {
          url
        }
      }
      ... on BrazilianCompanyIssuer {
        _id
        name
        businessDescription
        tickerSymbolPrefix
        securities {
          _id
          tickerSymbol
        }
        primaryLogo: standardLogo {
          url
        }
        niceLogo {
          url
        }
      }
      ... on BrazilianRealEstateFund {
        _id
        name
        shortDescription
        tickerSymbol
        tickerSymbolPrefix
        primaryLogo {
          url
          width
          height
        }
      }
    }

    author {
      ...CommentOrReplyAuthorFields
    }

    viewerCanDestroy
    viewerCanEdit
    viewerCanReply

    ...LockableCommentFields
    ...PinnableCommentFields
    ...EditableCommentFields
    ...ReactableFields
  }

  ${LockableCommentFields}
  ${PinnableCommentFields}
  ${EditableCommentFields}
  ${CommentOrReplyAuthorFields}
  ${ReactableFields}
`;
